/**
 * src/index.js — TabedLab
 *
 * Uses hydrateRoot when react-snap has pre-rendered HTML for this route,
 * and falls back to createRoot for routes that weren't pre-rendered
 * (auth pages, dev mode, etc.).
 *
 * This is required for react-snap (configured in package.json) to work
 * without hydration mismatch warnings.
 */

import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

if (container.hasChildNodes()) {
  // react-snap has already rendered static HTML → hydrate it
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // First-time render (dev mode or non-prerendered route)
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
